import { useCallback } from 'react';
import { Check } from 'react-feather';

import { useStyle } from '@/classify';
import Icon from '../Icon/icon';
import defaultClasses from './sortItem.module.css';

const SortItem = props => {
  const { active, onClick, sortItem } = props;
  const classes = useStyle(defaultClasses, props.classes);

  const handleClick = useCallback(
    e => {
      // use only left click for selection
      if (e.button === 0) {
        onClick(sortItem);
      }
    },
    [sortItem, onClick],
  );

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(sortItem);
      }
    },
    [onClick, sortItem],
  );

  const activeIcon = active ? (
    <Icon
      size={20}
      src={Check}
    />
  ) : null;

  const sortText = text => {
    if (text === 'Position') {
      return 'Featured';
    }

    return text;
  };

  return (
    <button
      type='button'
      className={classes.root}
      data-cy={active ? 'SortItem-activeButton' : 'SortItem-button'}
      onClick={handleClick}
    >
      <span className={classes.content}>
        <span className={classes.text}>{sortText(sortItem.text)}</span>
        {/* {activeIcon} */}
      </span>
    </button>
  );
};

export default SortItem;
